"use client";

import { useState, type FC, type Ref } from "react";
import { UploadCard, useDebug } from "@huub-web/ui";

import { useTemplates } from "../../hooks/useTemplates";

export interface UploadCardTemplateProps {
  /**
   * Markdown enabled
   */
  title: string;
  /**
   * Markdown enabled
   */
  body?: string;
  /**
   * The endpoint to upload the files to
   */
  endpoint: string;
  /**
   * The accepted file types
   */
  accepted?: ("pdf" | "doc" | "image")[];
  /**
   * Whether the card is disabled
   */
  disabled?: boolean;
}

/**
 * A template for an upload card.
 */
export const UploadCardTemplate: FC<
  UploadCardTemplateProps & { ref?: Ref<HTMLButtonElement> }
> = ({
  title,
  body,
  disabled,
  endpoint,
  accepted = ["pdf", "doc", "image"],
  ref,
}) => {
  const { uploadDocument, lockUI } = useTemplates();
  const [isUploading, setIsUploading] = useState(false);
  const { log } = useDebug();

  const allowedTypes: string[] = accepted.flatMap((type) => {
    switch (type) {
      case "pdf":
        return ["application/pdf"];
      case "doc":
        return ["application/msword"];
      case "image":
        return ["image/png", "image/jpeg", "image/gif", "image/webp"];
      default:
        return [];
    }
  });

  const handUpload = async (files: File[]) => {
    const file = files[0];
    log("purple", "UploadCardTemplate", "handleFileUpload", file);

    if (!file) {
      return;
    }

    setIsUploading(true);

    const response = await uploadDocument(endpoint, file);
    if (!response.success) {
      // TODO?
    }

    setIsUploading(false);
  };

  return (
    <UploadCard
      ref={ref}
      title={title}
      body={body}
      onUpload={handUpload}
      acceptedTypes={allowedTypes}
      disabled={isUploading || disabled || lockUI}
      loading={isUploading}
    />
  );
};
